/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ time: NonNullable<unknown> }} Meeting_Offline_Recording_BodyInputs */



/**
* | output |
* | --- |
* | "Through this device's microphone, since {time}." |
*
* @param {Meeting_Offline_Recording_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_offline_recording_body = /** @type {((inputs: Meeting_Offline_Recording_BodyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Offline_Recording_BodyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`Via de micro van dit toestel, sinds ${i?.time}.`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Via le micro de cet appareil, depuis ${i?.time}.`)
	return /** @type {LocalizedString} */ (`Through this device's microphone, since ${i?.time}.`)
});